import { render, staticRenderFns } from "./HealthStats.vue?vue&type=template&id=f7c982a2&scoped=true&lang=pug&"
import script from "./HealthStats.vue?vue&type=script&lang=js&"
export * from "./HealthStats.vue?vue&type=script&lang=js&"
import style0 from "./HealthStats.vue?vue&type=style&index=0&id=f7c982a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c982a2",
  null
  
)

/* custom blocks */
import block0 from "./HealthStats.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports